import React from "react";
import { Helmet } from 'react-helmet-async';

function AboutUs() {
  return (

    <div className="p-8 max-w-4xl mx-auto">
      <Helmet>
                <title>About us</title>
                <meta name="description" content="mushroom spores syringes" />
            </Helmet>
      <h1 className="text-3xl font-bold mb-4">About Us</h1>
      <p className="text-gray-700 mb-4">
        Welcome to Crow Spores.Our mission to provide the best quality Mushroom spores syringes,and cultivation kits.
      </p>
      <p className="text-gray-700">
        Our mission is to be the number #1 supplier of mushroom spores syringes and cultivation kits .
      </p>
      <p>Our motto is "Sustainability-eco-friendly-accessibility" </p>
    </div>
  );
}

export default AboutUs;
